import { Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard/Home';
import VehicleRequestsList from './vehicleListView';
import VehicleRequestDetail from './vehicleRequestDetail';
import QuotationDetail from './quotationDetail';
import PurchaseOrderList from './purchaseOrderList';
import PurchaseOrderDetail from './purchaseOrderDetail';
import RunningVehicleList from './runningVehicleList';
import RunningVehicleDetail from './runningVehicleDetail';
import LogSheet from './logSheet';
import LogSheetReport from './logSheetReport';
import Report from './report';
import IOCLReport from './ioclReport';

function VehicleRoutes() {
  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="vehicle-requests" element={<VehicleRequestsList />} />
      <Route path="vehicle-requests/:id" element={<VehicleRequestDetail />} />
      <Route path="vehicle-requests/:requestId/quotations/:quotationId" element={<QuotationDetail />} />
      <Route path="purchase-orders" element={<PurchaseOrderList />} />
      <Route path="purchase-orders/:purchaseId" element={<PurchaseOrderDetail />} />
      <Route path="running-vehicle" element={<RunningVehicleList />} />
      <Route path="running-vehicle/:id" element={<RunningVehicleDetail />} />
      <Route path="log-sheet" element={<LogSheet />} />
      <Route path="log-sheet-report" element={<LogSheetReport />} />
      <Route path="report" element={<Report />} />
      <Route path="iocl-report" element={<IOCLReport />} />
    </Routes>
  );
}

export default VehicleRoutes;
